import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { ButtonSizeVariants } from "@insite/mobius/Button";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
    getDataOptionValue,
} from "@store/Framework/Common/Utilities/dataOptions";
import { LiteralUnion } from "@store/Framework/Types/Common";
import { useMemo } from "react";

export type ButtonSizeVariantOption = DataOption;
export interface ButtonSizeVariantOptionMapper {
    small: ButtonSizeVariantOption;
    medium: ButtonSizeVariantOption;
    large: ButtonSizeVariantOption;
    xlarge: ButtonSizeVariantOption;
}
export type ButtonSizeVariantOptions = DataOptions<ButtonSizeVariantOption> & ButtonSizeVariantOptionMapper;
export type ButtonSizeVariant = LiteralUnion<keyof ButtonSizeVariantOptionMapper>;

export const buttonSizeVariantOptions: ButtonSizeVariantOptions = {
    small: { id: "small", displayName: "Small" },
    medium: { id: "medium", displayName: "Medium", isDefault: true },
    large: { id: "large", displayName: "Large" },
    xlarge: { id: "xlarge", displayName: "Very Large" },
};

export type ButtonSizeVariantFieldValue = ButtonSizeVariant | undefined;
export interface ButtonSizeVariantFieldOptions {
    isChildDefinition?: boolean;
}

export const getButtonSizeVariantFieldData = (
    value: ButtonSizeVariantFieldValue,
    options?: ButtonSizeVariantFieldOptions,
) => {
    if (!value) {
        return undefined;
    }

    return getDataOptionValue(buttonSizeVariantOptions, value) as ButtonSizeVariants;
};

export const getButtonSizeVariantFieldDefinition = (name: string, options?: ButtonSizeVariantFieldOptions) => {
    const { isChildDefinition } = options || {};

    const definition: DropDownFieldDefinition<string> = {
        ...getDataOptionsFieldDefinition(buttonSizeVariantOptions),
        name,
        displayName: "Button Size",
        fieldType: !isChildDefinition ? "General" : (undefined as any),
        hideEmptyOption: true,
    };

    return definition;
};

const getButtonSizeVariantField = (name: string, options?: ButtonSizeVariantFieldOptions) => {
    const parse = (value: ButtonSizeVariantFieldValue) => getButtonSizeVariantFieldData(value, options);

    return {
        definition: getButtonSizeVariantFieldDefinition(name, options),
        parse,
        useParse: (...parameters: Parameters<typeof parse>) => {
            return useMemo(() => parse(...parameters), parameters);
        },
    };
};

export default getButtonSizeVariantField;
